<template>
  <div class="f20-l23-m margin-top-25 ">{{ this.title }}</div>
</template>
<script>
export default {
  props: ["title"]
}
</script>